<div class="p-relative">
    <ng-select
    #selectRef
    [ngClass]="class ? class : null"
    [items]="items"
    [multiple]="multiple"
    [searchable]="searchable"
    [clearable]="clearable"
    [placeholder]="placeholder"
    [ariaLabel]="label || placeholder"
    [bindLabel]="displayKey"
    [bindValue]="bindValue || null"
    [loading]="loading"
    [(ngModel)]="value"
    (search)="onSearch($event)"
    (change)="onChange($event)"
    (clear)="selectionCleared.emit()"
    class="custom-ng-select"
    [compareWith]="compareByValue"
  >
  </ng-select>
  <div  
    role="button"
    tabindex="0"
    (click)="selectRef.open()"
    (keydown.enter)="selectRef.open()" 
    [ngClass]="iconPosition ? 'p-pos-icon-left' : 'p-pos-icon'">
    <i class="sd icon-20" [ngClass]="icon ? 'sd-chevron-down' : 'sd-search-refraction'"></i>
  </div>
</div>